import { render, staticRenderFns } from "./RefreshIconWhite.vue?vue&type=template&id=2796796b&"
import script from "./RefreshIconWhite.vue?vue&type=script&lang=js&"
export * from "./RefreshIconWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports